import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8EC8847F-E96F-4D14-BF88-F4BE47856865
 * name image-filter-frames
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-frames.svg
 * tags
 * - Photography 
 */
export const ImageFilterFramesIcon = createSvgIcon(<><path d="M18,8H6V18H18M20,20H4V6H8.5L12.04,2.5L15.5,6H20M20,4H16L12,0L8,4H4A2,2 0 0,0 2,6V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V6A2,2 0 0,0 20,4Z" /></>, 'ImageFilterFramesIcon');
export default ImageFilterFramesIcon